import {
  couponList,
  couponCreate,
  couponUpdate,
  couponDestroy,
} from '@/services/shop/coupons.service'

export default {
  namespaced: true,
  state: {
    coupons: { data: [], meta: { pagination: { total: 0 } } },
    status: 'init',
  },
  getters: {
    getCoupons: s => s.coupons,
    getStatus: s => s.status,
  },
  mutations: {
    SET_COUPONS(state, value) { state.coupons = value },
    SET_STATUS(state, value) { state.status = value },
  },
  actions: {
    async fetchCoupons({ commit }, params) {
      commit('SET_STATUS', 'pending')
      try {
        const { data } = await couponList(params)
        commit('SET_COUPONS', data)
      } catch (e) {
        this._vm.$root.$notify({ message: e?.response?.data?.message || 'Error', type: 'danger' })
      } finally {
        commit('SET_STATUS', 'init')
      }
    },

    async saveCoupon({ dispatch }, { form, page, perPage }) {
      const action = form.id ? couponUpdate(form.id, form) : couponCreate(form)
      await action
      dispatch('fetchCoupons', { page, per_page: perPage })
    },

    async removeCoupon({ dispatch }, { id, page, perPage }) {
      await couponDestroy(id)
      dispatch('fetchCoupons', { page, per_page: perPage })
    },
  },
}
